import TodasComprasDiretas from '@/views/pages/comprador/todas-compras-diretas/TodasComprasDiretas'
import ExecucaoCompraDiretaComprador from '@/views/pages/comprador/execucao-compra-direta/ExecucaoCompraDireta'
import DadosGeraisVisualizacaoComprador from '@/views/pages/comprador/execucao-compra-direta/dados-gerais/DadosGeraisVisualizacao'
import DadosGeraisEdicaoComprador from '@/views/pages/comprador/execucao-compra-direta/dados-gerais/DadosGeraisEdicao'
import ItensLotesVisualizacaoComprador from '@/views/pages/comprador/execucao-compra-direta/itens-lotes/ItensLotesVisualizacao'
import ItensLotesEdicaoComprador from '@/views/pages/comprador/execucao-compra-direta/itens-lotes/ItensLotesEdicao'
import ComprasDiretasEmAndamento from '@/views/pages/comprador/compras-diretas-em-andamento/ComprasDiretasEmAndamento'
import ComprasDiretasEncerradas from '@/views/pages/comprador/compras-diretas-encerradas/ComprasDiretasEncerradas'
import ComprasDiretasEmElaboracao from '@/views/pages/comprador/compras-diretas-em-elaboracao/ComprasDiretasEmElaboracao'
import DocumentosEdicaoComprador from '@/views/pages/comprador/execucao-compra-direta/documentos/DocumentosEdicao'
import DocumentosVisualizacaoComprador from '@/views/pages/comprador/execucao-compra-direta/documentos/DocumentosVisualizacao'
import AcompanhamentoComprador from '@/views/pages/comprador/execucao-compra-direta/acompanhamento/Acompanhamento'
import AnaliseDocumentacao from '@/views/pages/comprador/analise-documentacao/AnaliseDocumentacao'
import ResultadoComprador from '@/views/pages/comprador/execucao-compra-direta/resultado/ResultadoComprador'
import ManualCompraDiretaComprador from '../../pages/comprador/manual-do-comprador/ManualCompraDiretaComprador'
import DocumentosCompraDiretaVirtualizada from '../../pages/comprador/execucao-compra-direta/resultado/documentos-compra-direta/DocumentosCompraDiretaVirtualizada'
import InformacoesSistemaDashboard from '../../pages/comprador/informacoes-sistema/InformacoesSistemaDashboard'
import FilaRequisicoes from '../../pages/comprador/informacoes-sistema/requisicoes/FilaRequisicoes'
import SobreCompraDireta from '@/views/pages/commons/sobre/SobreCompraDireta'
import AZCronosInformacao from '@/views/pages/commons/sobre/cronos/AZCronosInformacao'
import PagePrincipalIndicePreco from '@/views/pages/comprador/cadastros/indice-de-preco/PagePrincipalIndicePreco'
import CadastrosWrapper from '@/views/pages/comprador/cadastros/CadastrosWrapper'
import CompraDiretaEmHomologacao from '@/views/pages/comprador/compras-diretas-em-homologacao/CompraDiretaEmHomologacao.vue'
import ComprasDiretasLegadas from '@/views/pages/comprador/legado/ComprasDiretasLegadas.vue'
import CompraDiretaLegadaDetalhes from '@/views/pages/comprador/legado/datalhes/CompraDiretaLegadaDetalhes.vue'
import CompraDiretaLegadaDetalhesCapa from '@/views/pages/comprador/legado/datalhes/CompraDiretaLegadaDetalhesCapa.vue'
import CompraDiretaLegadaDetalhesItens from '@/views/pages/comprador/legado/datalhes/CompraDiretaLegadaDetalhesItens.vue'
import CompraDiretaLegadaDetalhesResultado from '@/views/pages/comprador/legado/datalhes/CompraDiretaLegadaDetalhesResultado.vue'
import DesemtranhamentoDocumento from '@/views/pages/comprador/execucao-compra-direta/resultado/documentos-compra-direta/DesemtranhamentoDocumento.vue'
import TermoDesentranhamento from '@/views/pages/comprador/execucao-compra-direta/resultado/documentos-compra-direta/TermoDesentranhamento.vue'
import TermoDesentranhamentoRedacao from '@/views/pages/comprador/execucao-compra-direta/resultado/documentos-compra-direta/redigir/TermoDesentranhamentoRedacao.vue'
import OcorrenciaEsfinge from '@/views/pages/comprador/execucao-compra-direta/acoes/OcorrenciaEsfinge.vue'
import EtapasIncluirProposta from '@/views/pages/comprador/execucao-compra-direta/resultado/incluir-proposta-manual/EtapasIncluirProposta'
import CompradorIncluirPropostaManualTermo from '@/views/pages/comprador/execucao-compra-direta/resultado/incluir-proposta-manual/termo/Termo'
import CompradorIncluirPropostaManualProposta from '@/views/pages/comprador/execucao-compra-direta/resultado/incluir-proposta-manual/proposta/Proposta'
import ConfiguracaoIncisos from '@/views/pages/comprador/cadastros/configuracao-prazo-amparo/ConfiguracaoIncisos.vue'
import ConfiguracaoIncisosCadastro from '@/views/pages/comprador/cadastros/configuracao-prazo-amparo/ConfiguracaoIncisosCadastro.vue'
import ConfiguracaoIncisosEdicao from '@/views/pages/comprador/cadastros/configuracao-prazo-amparo/ConfiguracaoIncisosEdicao.vue'
import ProtocoloOcorrencia from '@/views/pages/comprador/execucao-compra-direta/esfinge/ProtocoloOcorrencia.vue'

const subtituloEdicaoCompraDireta = 'Edição da compra direta'
const compradorNormalAuth = 'Comprador.Normal'
const compradorAutSuperior = 'Comprador.Autoridade.Superior'
const compradorAdminAuth = 'Comprador.Admin'
const compradorConsultaAuth = 'Comprador.Consulta'
const tituloCompraDireta = 'Compra Direta'
const subtituloVisualizacaoCompraDireta = 'Visualização da compra direta'

const fullAcesso = [compradorNormalAuth, compradorAdminAuth, compradorConsultaAuth, compradorAutSuperior]

export default [
    {
        path: '/comprador/todas',
        name: 'TodasComprasDiretas',
        component: TodasComprasDiretas,
        meta: {
            menu: {
                title: 'Todas',
                icon: 'fas fa-tags'
            },
            page: {
                title: 'Todas as Compras Diretas',
                subtitle: 'Lista geral de compras diretas eletrônicas'
            },
            requiresAuth: true,
            authorities: fullAcesso
        }
    },
    {
        path: '/comprador/autoridade-superior/homologacao',
        name: 'CompraDiretaEmHomologacao',
        component: CompraDiretaEmHomologacao,
        meta: {
            page: {
                title: 'Compras Diretas em Homologação',
                subtitle: 'Lista geral de compras diretas em homologação'
            },
            scrollToTop: true,
            requiresAuth: true,
            authorities: [compradorAutSuperior]
        }
    },
    {
        path: '/comprador/elaboracao',
        name: 'ComprasDiretasEmElaboracao',
        component: ComprasDiretasEmElaboracao,
        meta: {
            menu: {
                title: 'Elaboração',
                icon: 'fas fa-edit'
            },
            page: {
                title: 'Compras Diretas em Elaboração',
                subtitle: 'Lista de compras diretas eletrônicas em elaboração'
            },
            requiresAuth: true,
            authorities: fullAcesso
        }
    },
    {
        path: '/comprador/andamento',
        name: 'ComprasDiretasEmAndamento',
        component: ComprasDiretasEmAndamento,
        meta: {
            menu: {
                title: 'Andamento',
                icon: 'fas fa-clock'
            },
            page: {
                title: 'Compras Diretas em Andamento',
                subtitle: 'Lista de compras diretas eletrônicas em andamento'
            },
            requiresAuth: true,
            authorities: fullAcesso
        }
    },
    {
        path: '/comprador/encerradas',
        name: 'ComprasDiretasEncerradas',
        component: ComprasDiretasEncerradas,
        meta: {
            menu: {
                title: 'Encerradas',
                icon: 'fas fa-check-square'
            },
            page: {
                title: 'Compras Diretas Encerradas',
                subtitle: 'Lista de compras diretas eletrônicas encerradas'
            },
            requiresAuth: true,
            authorities: fullAcesso
        }
    },
    {
        path: '/comprador/compras-diretas/legadas',
        name: 'ComprasDiretasLegadas',
        component: ComprasDiretasLegadas,
        meta: {
            menu: {
                title: 'Processos Legado',
                icon: 'fas fa-folder-open'
            },
            page: {
                title: 'Compras Diretas Legadas',
                subtitle: 'Lista de compras diretas eletrônicas encerradas do sistema legado'
            },
            requiresAuth: true,
            authorities: fullAcesso
        }
    },
    {
        path: '/comprador/compras-diretas/legadas/:id',
        component: CompraDiretaLegadaDetalhes,
        meta: {
            page: {
                title: 'Compras Diretas Legadas Detalhes',
                subtitle: 'Detalhes da compra direta legada'
            },
            requiresAuth: true,
            authorities: fullAcesso
        },
        children: [
            {
                path: 'detalhes',
                name: 'CompraDiretaLegadaDetalhesCapa',
                component: CompraDiretaLegadaDetalhesCapa,
                meta: {
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: 'itens',
                name: 'CompraDiretaLegadaDetalhesItens',
                component: CompraDiretaLegadaDetalhesItens,
                meta: {
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: 'execucoes/:execucaoId/resultado',
                name: 'CompraDiretaLegadaDetalhesResultado',
                component: CompraDiretaLegadaDetalhesResultado,
                meta: {
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            }
        ]
    },
    {
        path: '/sobre',
        name: 'SobreCompraDireta',
        component: SobreCompraDireta,
        redirect: '/sobre/novidades',
        meta: {
            menu: {
                title: 'Sobre',
                icon: 'fas fa-lightbulb'
            },
            requiresAuth: true,
            authorities: fullAcesso
        },
        children: [
            {
                path: '/sobre/novidades',
                name: 'Novidades',
                component: AZCronosInformacao,
                meta: {
                    menu: {
                        icon: 'newspaper',
                        title: 'Novidades',
                    },
                    page: {
                        title: 'Sobre Compra Direta',
                        subtitle: 'Novidades'
                    },
                    cronosCategoria: 'novidades',
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: '/sobre/sugestoes',
                name: 'Sugestoes',
                component: AZCronosInformacao,
                meta: {
                    menu: {
                        icon: 'rate_review',
                        title: 'Sugestões',
                    },
                    page: {
                        title: 'Sobre Compra Direta',
                        subtitle: 'Sugestões'
                    },
                    cronosCategoria: 'sugestoes',
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: '/sobre/roadmaps',
                name: 'Roadmaps',
                component: AZCronosInformacao,
                meta: {
                    menu: {
                        icon: 'route',
                        title: 'Roadmaps',
                    },
                    page: {
                        title: 'Sobre Compra Direta',
                        subtitle: 'Roadmaps'
                    },
                    cronosCategoria: 'roadmaps',
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: '/sobre/manualComprador',
                name: 'ManualCompraDiretaComprador',
                component: ManualCompraDiretaComprador,
                meta: {
                    menu: {
                        icon: 'fas fa-lightbulb',
                        title: 'Manual',
                    },
                    page: {
                        title: 'Sobre Compra Direta',
                        subtitle: 'Manual do servidor'
                    },
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
        ]
    },
    {
        path: '/comprador/execucao/:id',
        name: 'ExecucaoCompraDireta',
        component: ExecucaoCompraDiretaComprador,
        children: [
            {
                path: 'dadosGerais/visualizacao',
                name: 'DadosGeraisVisualizacao',
                component: DadosGeraisVisualizacaoComprador,
                meta: {
                    page: {
                        title: tituloCompraDireta,
                        subtitle: subtituloVisualizacaoCompraDireta
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: 'dadosGerais/edicao',
                name: 'DadosGeraisEdicao',
                component: DadosGeraisEdicaoComprador,
                meta: {
                    page: {
                        title: tituloCompraDireta,
                        subtitle: subtituloEdicaoCompraDireta
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [compradorNormalAuth, compradorAdminAuth, compradorAutSuperior]
                }
            },
            {
                path: 'itensLotes/visualizacao',
                name: 'ItensLotesVisualizacao',
                component: ItensLotesVisualizacaoComprador,
                meta: {
                    page: {
                        title: tituloCompraDireta,
                        subtitle: subtituloVisualizacaoCompraDireta
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: 'itensLotes/edicao',
                name: 'ItensLotesEdicao',
                component: ItensLotesEdicaoComprador,
                meta: {
                    page: {
                        title: tituloCompraDireta,
                        subtitle: subtituloEdicaoCompraDireta
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [compradorNormalAuth, compradorAdminAuth, compradorAutSuperior]
                }
            },
            {
                path: 'documentos/edicao',
                name: 'DocumentosEdicao',
                component: DocumentosEdicaoComprador,
                meta: {
                    page: {
                        title: tituloCompraDireta,
                        subtitle: subtituloEdicaoCompraDireta
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: [compradorNormalAuth, compradorAdminAuth, compradorAutSuperior]
                }
            },
            {
                path: 'documentos/visualizacao',
                name: 'DocumentosVisualizacao',
                component: DocumentosVisualizacaoComprador,
                meta: {
                    page: {
                        title: tituloCompraDireta,
                        subtitle: subtituloVisualizacaoCompraDireta
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: 'acompanhamento/visualizacao',
                name: 'AcompanhamentoVisualizacao',
                component: AcompanhamentoComprador,
                meta: {
                    page: {
                        title: tituloCompraDireta,
                        subtitle: subtituloVisualizacaoCompraDireta
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: 'resultado',
                name: 'Resultado',
                component: ResultadoComprador,
                meta: {
                    page: {
                        title: tituloCompraDireta,
                        subtitle: subtituloVisualizacaoCompraDireta
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: 'ocorrencia-esfinge',
                name: 'OcorrenciaEsfinge',
                component: OcorrenciaEsfinge,
                meta: {
                    page: {
                        title: tituloCompraDireta,
                        subtitle: 'Ocorrência E-Sfinge'
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: 'ocorrencia-protocolo',
                name: 'ProtocoloOcorrencia',
                component: ProtocoloOcorrencia,
                meta: {
                    page: {
                        title: tituloCompraDireta,
                        subtitle: 'Protocolo de Ocorrências'
                    },
                    scrollToTop: true,
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
        ]
    },
    {
        path: '/comprador/compra-direta/:id/incluir-proposta-manual',
        name: 'CompradorIncluirPropostaManual',
        component: EtapasIncluirProposta,
        meta: {
            requiresAuth: true,
            authorities: fullAcesso
        },
        children: [
            {
                path: 'termo',
                name: 'CompradorIncluirPropostaManualTermo',
                component: CompradorIncluirPropostaManualTermo
            },
            {
                path: 'proposta/:propostaId/fornecedor/:fornecedorId',
                name: 'CompradorIncluirPropostaManualProposta',
                component: CompradorIncluirPropostaManualProposta
            }
        ]
    },
    {
        path: '/comprador/compra-direta/:id/fornecedor/:fornecedorId/:itemLoteTipo/:itemLoteId',
        name: 'AnaliseDocumentacao',
        component: AnaliseDocumentacao,
        meta: {
            requiresAuth: true,
            authorities: fullAcesso
        }
    },
    {
        path: '/comprador/compra-direta/:id/documentosCompraDireta',
        name: 'documentosCompraDireta',
        component: DocumentosCompraDiretaVirtualizada,
        meta: {
            requiresAuth: true,
            authorities: fullAcesso
        }
    },
    {
        path: '/informacoes-sistema',
        name: 'InformacoesSistema',
        component: InformacoesSistemaDashboard,
        meta: {
            page: {
                title: 'Situação Integrações',
                subtitle: 'Listagem de informações',
            },
            requiresAuth: true,
            authorities: fullAcesso
        }
    },
    {
        path: '/informacoes-sistema/:sistema/requisicoes',
        name: 'FilaRequisicoes',
        component: FilaRequisicoes,
        meta:{
            page: {
                title: 'Requisições',
                subtitle: 'Fila de requisições do sistema integrado'
            },
            requiresAuth: true,
            authorities: fullAcesso
        }
    },
    {
        path: '/comprador/cadastros',
        name: 'Cadastros',
        component: CadastrosWrapper,
        redirect: '/comprador/cadastros/indices-precos',
        meta: {
            menu: {
                title: 'Cadastros',
                icon: 'settings'
            },
            requiresAuth: true,
            authorities: fullAcesso
        },
        children: [
            {
                path: '/comprador/cadastros/indices-precos',
                name: 'IndicesPrecos',
                component: PagePrincipalIndicePreco,
                meta: {
                    menu: {
                        icon: 'insights',
                        title: 'Índices de Preços',
                    },
                    page: {
                        title: 'Índices de Preços',
                        subtitle: 'IPCA'
                    },
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: '/comprador/cadastros/incisos-menu',
                name: 'ConfiguracaoPrazoIncisosMenu',
                redirect: '/comprador/cadastros/incisos',
                meta: {
                    menu: {
                        icon: 'book',
                        title: 'Incisos'
                    },
                    page: {
                        title: 'Incisos',
                        subtitle: 'Configuração de Prazo'
                    },
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: '/comprador/cadastros/incisos',
                name: 'ConfiguracaoIncisos',
                component: ConfiguracaoIncisos,
                meta: {
                    page: {
                        title: 'Incisos',
                        subtitle: 'Configuração de Prazo por Amparo Legal'
                    },
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: '/comprador/cadastros/incisos/cadastro',
                name: 'ConfiguracaoIncisosCadastro',
                component: ConfiguracaoIncisosCadastro,
                meta: {
                    page: {
                        title: 'Cadastro de Inciso',
                        subtitle: 'Configuração de Prazo por Amparo Legal'
                    },
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            },
            {
                path: '/comprador/cadastros/incisos/edicao',
                name: 'ConfiguracaoIncisosEdicao',
                component: ConfiguracaoIncisosEdicao,
                meta: {
                    page: {
                        title: 'Edição de Inciso',
                        subtitle: 'Configuração de Prazo por Amparo Legal'
                    },
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            }
        ]
    },
    {
        path: '/comprador/compras-diretas/:id/documentos/:documentoId/tipo/:tipoDocumento',
        name: 'DesemtranhamentoDocumento',
        component: DesemtranhamentoDocumento,
        meta: {
            requiresAuth: true,
            authorities: fullAcesso
        }
    },
    {
        path: '/comprador/termo-desentranhamento/:idTermo',
        name: 'TermoDesentranhamento',
        component: TermoDesentranhamento,
        meta: {
            requiresAuth: true,
            authorities: fullAcesso
        },
        children: [
            {
                path: 'redigir',
                name: 'termoDesentranhamentoRedigir',
                component: TermoDesentranhamentoRedacao,
                meta: {
                    requiresAuth: true,
                    authorities: fullAcesso
                }
            }
        ]
    }
]
